// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","624":"fb7d5399","869":"styles"}[chunkId] + "-" + {"245":"e7bb7dddfb932ae33669","453":"794dd46ed3fe38359718","624":"d6e683de37537aa58bec","869":"9713e643c5defe9f9374"}[chunkId] + ".js";
};